module.exports = __webpack_public_path__ + "img/cloud_tool_errorbar.f1778d04.jpg";